const cleave = require('base/components/cleave');

let klarnaCheckout;
try {
  klarnaCheckout = require('link_klarnapayments_byl/klarnaCheckout');
} catch (e) {
  klarnaCheckout = null;
}

const base = require('instorepickup/checkout/billing');
const addressHelpers = require('./address');
const clientSideValidation = require('../components/clientSideValidation');
const modals = require('../components/modals');
const formHelpers = require('./formErrors');
const formUtils = require('../common/utils/formUtils');
const {
  forEachElement,
  hideElementsBySelector,
  showElementsBySelector,
} = require('../common/utils/dom');
const checkoutStage = require('./checkoutStage');
const getAnalyticsEventCenter = require('../common/getAnalyticsEventCenter');
const { default: getFrontConfig } = require('../common/getFrontConfig');

const analyticsEventCenter = getAnalyticsEventCenter();

const {
  checkout: {
    adyenPaymentMethods,
    paymentMethods,
  },
} = getFrontConfig();

const adyenPaymentsWithoutDetails = [
  adyenPaymentMethods.SOFORT.type,
];

const PAYMENT_SESSION_ATTR = 'selectedPaymentMethod';

const billingAddressFormSelector = '#dwfrm_billing';
const billingAddressSelector = '.billing-address';
const billingAddressBlockSelector = '.billing-address-block';
const billingAddressSelectorSelector = '.billing-selector-block';
const billingAddressFormErrorSelector = '.submit-billing-error';
const billingAddressSerializeEvent = 'checkout:serializeBilling';
/**
 * Set or retrieve the value of a billing-related data attribute.
 * The data will be stored in the DOM as a data attribute of the billing form.
 *
 * @param {string} key camel-cased name of the attribute (without 'data' prefix)
 * @param {string} [value] if no value is passed, then it will be a read-only action
 * @returns {string} value stored in data attribute
 *
 * @example
 *  setter:
 *    billingDomData('shippingMethod', 'new');  => 'new'
 *  getter:
 *    billingDomData('shippingMethod');  => 'new'
 *  stored as:
 *    data-shipping-method="new"
 */
function billingDomData(key, value) {
  const form = document.querySelector(billingAddressFormSelector);
  if (!form) throw new Error(`Billing main form "${billingAddressFormSelector}" not found`);

  let result;
  if (arguments.length > 1) {
    form.dataset[key] = value;
    result = value;
  } else {
    result = form.dataset[key];
  }
  return result;
}

/**
 * Prepare ajax data for Payment Submit
 * @returns {string} serialized string to send in the ajax call
 */
function preparePaymentData() {
  /* Billing address */
  const billingAddressFormBlockSelector = `${billingAddressFormSelector} ${billingAddressBlockSelector}`;
  let billingAddressForm = $(`${billingAddressFormBlockSelector} :input`).serialize();
  $('body').trigger(billingAddressSerializeEvent, {
    form: $(billingAddressFormBlockSelector),
    data: billingAddressForm,
    callback(data) {
      if (data) {
        billingAddressForm = data;
      }
    },
  });

  /* Contact info */
  const contactInfoFormSelector = `${billingAddressFormSelector} .contact-info-block`;
  let contactInfoForm = $(`${contactInfoFormSelector} :input`).serialize();
  $('body').trigger(billingAddressSerializeEvent, {
    form: $(contactInfoFormSelector),
    data: contactInfoForm,
    callback(data) {
      if (data) {
        contactInfoForm = data;
      }
    },
  });

  /* Adyen card installments */
  const paymentNavItemElement = document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode;
  if (paymentNavItemElement?.dataset) {
    const {
      methodId: selectedPaymentMethod = null
    } = paymentNavItemElement.dataset;
    if (selectedPaymentMethod === 'AdyenComponent' && window.AdyenInstallmentsEnabled && window.AdyenInstallmentsOptions) {
      let cardInstallments = null;
      const selectedCardInput = $('input[name="brandCode"]:checked');
      if (selectedCardInput.val().indexOf('scheme') !== -1) {
        cardInstallments = $('#adyen-new-card-installments select').val();
      } else if (selectedCardInput.val().indexOf('storedCard') !== -1) {
        cardInstallments = selectedCardInput.closest('li').find('.adyen-checkout__custominstallments select').val();
      }
      if (cardInstallments && parseInt(cardInstallments, 10) > 1) {
        const adyenStateDataMod = JSON.parse($('#adyenStateData').val());
        adyenStateDataMod.installments = { value: cardInstallments };
        $('#adyenStateData').val(JSON.stringify(adyenStateDataMod));
      }
    }
  }

  /* Payment info */
  const activeTabId = $('.credit-card-selection-new .tab-pane.active').attr('id');
  const paymentInfoSelector = `${billingAddressFormSelector} .${activeTabId} .payment-form-fields :input`;
  let paymentInfoForm = $(paymentInfoSelector).serialize();
  $('body').trigger(billingAddressSerializeEvent, {
    form: $(paymentInfoSelector),
    data: paymentInfoForm,
    callback(data) {
      if (data) {
        paymentInfoForm = data;
      }
    },
  });

  return `${billingAddressForm}&${contactInfoForm}&${paymentInfoForm}`;
}

/**
 * Prepares Payment Data and transforms it as FormData
 * @returns {formData} formData to send in a XHR request
 */
function getPaymentFormData() {
  const formData = new FormData();
  const serializedPaymentData = preparePaymentData();

  serializedPaymentData.split('&').forEach((input) => {
    const inputArray = input.split('=');
    formData.append(inputArray[0], decodeURIComponent(inputArray[1]));
  });

  return formData;
}

/**
 * Handle response for Payment Submit
 * @param  {Object} data - ajax response data
 */
function handlePaymentSubmitResponse(data) {
  if (data.error) {
    if (data.showModal) {
      modals.createCustomModal(data.modalHtml, { backdrop: 'static' }, data.includeAssets);
      return;
    }

    const { errorMessage } = data;
    formHelpers.addCheckoutError(errorMessage);

    if (data.fieldErrors?.length) {
      data.fieldErrors.forEach((error) => {
        if (Object.keys(error).length) {
          formUtils.loadFormErrors('.payment-form', error);
        }
      });
    }

    if (data.serverErrors?.length) {
      data.serverErrors.forEach((error) => {
        const invalidCardError = $('#invalidCardDetails');
        invalidCardError.text(error);
        invalidCardError.show();
      });
    }

    handleMercadoPagoFormErrors();

    if (isAdyenComponentSelected()) {
      const adyenCheckout = require('on4u_adyen_SFRA/adyenCheckout');
      adyenCheckout.handleAdyenPaymentErrors(data);
    }

    $('.payment-form').addClass('payment-form--form-error');

    // TODO check errors and go to suitable stage
    checkoutStage.methods.setStage(checkoutStage.stages.PAYMENT_DETAILS);

    if (data.cartError) {
      window.location.href = data.redirectUrl;
    }
  } else {
    $('body').trigger('checkout:payment-saved', data.order);
    // Send info for Analytics
    analyticsEventCenter.publish(
      analyticsEventCenter.EVENTS.checkoutPaymentInfoAdded,
      {
        order: data.order,
      },
    );
  }
}

function handleMercadoPagoFormErrors() {
  if ($('#mercadopago-content').length > 0) {
    const $mercadoPagoEmail = $('#mercadoPagoEmail');
    const $mercadoPagoPhone = $('#mercadoPagoPhoneNumber');

    if ($mercadoPagoEmail.val() === ''
      || $mercadoPagoPhone.val() === ''
    ) {
      $mercadoPagoEmail.closest('.form__fields-row').removeClass('d-none');
    }
  }
}

/**
 * Updates the billing address form values within payment forms without any payment instrument validation
 * @param {Object} order - the order model
 */
function updateBillingAddress(order) {
  const { billing } = order;
  if (!billing.billingAddress || !billing.billingAddress.address) return;

  const addressObject = billing.billingAddress.address;
  const form = $(billingAddressFormSelector);
  const formSelector = '[name*=_billing_]:not([data-autocomplete-form=off])';
  if (!form) return;

  $(`input${formSelector}[name$=_title]`, form).val(addressObject.title);
  $(`input${formSelector}[name$=_firstName]`, form).val(addressObject.firstName);
  $(`input${formSelector}[name$=_lastName]`, form).val(addressObject.lastName);
  $(`input${formSelector}[name$=_address1]`, form).val(addressObject.address1);
  $(`input${formSelector}[name$=_address2]`, form).val(addressObject.address2);
  $(`input${formSelector}[name$=_city]`, form).val(addressObject.city);
  $(`input${formSelector}[name$=_postalCode]`, form).val(addressObject.postalCode);

  const stateElement = $(`select${formSelector}[name$=_stateCode],input${formSelector}[name$=_stateCode]`, form);
  const stateElementEnabledOptions = $('option:not([disabled])', stateElement);
  if (stateElementEnabledOptions.length === 1) {
    stateElement.val(stateElementEnabledOptions.attr('value'));
  } else {
    stateElement.val(addressObject.stateCode);
  }
  const stateSelect = $(`select${formSelector}[name$=_stateCode]`, form);
  if (stateSelect.length) {
    stateSelect.change();
  }

  const { countryCode } = addressObject;
  const countrySelect = $(`select${formSelector}[name$=_country]`, form);
  const countrySelectEnabledOptions = $('option:not([disabled])', countrySelect);

  if (countrySelectEnabledOptions.length === 1) {
    countrySelect.val(countrySelectEnabledOptions.attr('value'));
  } else if (countryCode && typeof countryCode === 'object') {
    countrySelect.val(countryCode.value);
  } else {
    countrySelect.val(countryCode);
  }
  countrySelect.change();

  $(`input${formSelector}[name$=_phone]`, form).val(addressObject.phoneBody
    ? addressObject.phoneBody
    : addressObject.phone);

  if (order.orderEmail) {
    $(`input${formSelector}[name$=_email]`, form).val(order.orderEmail);
  }
}

/**
 * Validate and update payment instrument form fields
 * @param {Object} order - the order model
 */
function validateAndUpdateBillingPaymentInstrument(order) {
  const { billing } = order;
  if (!billing.payment || !billing.payment.selectedPaymentInstruments
    || billing.payment.selectedPaymentInstruments.length <= 0) return;

  const form = $(billingAddressFormSelector);
  if (!form) return;

  const instrument = billing.payment.selectedPaymentInstruments[0];

  $('select[name$=expirationMonth]', form).val(instrument.expirationMonth);
  $('select[name$=expirationYear]', form).val(instrument.expirationYear);
  if (instrument.paymentMethod === 'MercadoPago') {
    // Force security code and card number clear, no name in mercado pago form since its never submitted
    $('#mercadoPagoSecurityCode', form).val('');
    $('#mercadoPagoCardNumber').data('cleave')?.setRawValue('');
  } else {
    // Force security code and card number clear
    $('input[name$=securityCode]', form).val('');
    $('input[name$=cardNumber]').data('cleave')?.setRawValue('');
  }
}

/**
 * Updates the billing address form values within payment forms
 * @param {Object} order - the order model
 */
function updateBillingAddressFormValues(order) {
  updateBillingAddress(order);
  validateAndUpdateBillingPaymentInstrument(order);
}

/**
 * updates the billing address selector with customer addresses
 * @param {Object} customer - the customer model
 */
function updateBillingAddressSelector(customer) {
  const form = $('.payment-form');
  const $billingAddressSelector = $('.addressSelector', form);
  if (!$billingAddressSelector && $billingAddressSelector.length < 1) return;

  if (customer.addresses && customer.addresses.length > 0) {
    customer.addresses.forEach((address) => {
      addressHelpers.methods.updateAddressOption({
        UUID: address.ID,
        address,
      });
    });
  }
}

/**
 * Updates the billing information in checkout, based on the supplied order model
 * @param {Object} order - checkout model to use as basis of new truth
 * @param {Object} [options] - options
 */
function updateBillingInformation(order, customer) {
  // update billing address form
  updateBillingAddressFormValues(order);

  updateBillingAddressSummary(order);

  updateBillingAddressSelector(customer);
}

function isAdyenComponentSelected() {
  const paymentNavItemElement = document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode;
  if (!paymentNavItemElement?.dataset) {
    return false;
  }

  const {
    methodId: selectedPaymentMethod = null
  } = paymentNavItemElement.dataset;
  const processedSelectedMethodId = selectedPaymentMethod.split('__')[0];
  return ([paymentMethods.AdyenComponent]
    .indexOf(processedSelectedMethodId) !== -1);
}

/**
 * checks if selected payment method has a Payment Details stage or not
 * @returns {boolean}
 */
function hasPaymentDetailsStage() {
  const paymentNavItemElement = document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode;
  if (!paymentNavItemElement?.dataset) {
    return false;
  }

  const {
    methodId: selectedPaymentMethod = null
  } = paymentNavItemElement.dataset;
  const processedSelectedMethodId = selectedPaymentMethod.split('__')[1];
  const paymentWithoutDetails = (adyenPaymentsWithoutDetails
    .indexOf(processedSelectedMethodId) !== -1);

  return !paymentWithoutDetails;
}

function isAssistedShoppingSelected() {
  const paymentNavItemElement = document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode;
  if (!paymentNavItemElement?.dataset) {
    return false;
  }

  const {
    methodId: selectedPaymentMethod = null
  } = paymentNavItemElement.dataset;

  return paymentMethods.ADYEN_PAYBYLINK.indexOf(selectedPaymentMethod) !== -1
    || paymentMethods.ADYEN_POS.indexOf(selectedPaymentMethod) !== -1
    || paymentMethods.REDELCOM.indexOf(selectedPaymentMethod) !== -1
    || paymentMethods.MERCADOPAGO_PAYBYLINK
      .indexOf(selectedPaymentMethod) !== -1;
}

function isAdyenComponentValid() {
  if (!isAdyenComponentSelected()) return false;
  const adyenCheckout = require('on4u_adyen_SFRA/adyenCheckout');
  return adyenCheckout.validateAdyenPayment();
}

function getAdyenComponentErrorMessage() {
  const paymentForm = document.querySelector('.payment-form');
  return paymentForm.dataset.adyenError;
}

/**
 * Submit the payment and returns a promise with the simplified status of the
 * payment.
 *
 * @example
 * When the payment is OK
 *  { error: false, canceled: false }
 * When an error occurs
 *  { error: true, errorMessage: '...', canceled: false }
 * When the user closes Klarna pop up and cancels the payment
 *  { error: false, canceled: true }
 * @returns {Promise<Object>} The payment status (error or canceled)
 */
async function submitPayment() {
  formHelpers.clearPreviousErrors('.payment-form');
  formHelpers.removeCheckoutError();

  if (isAdyenComponentSelected() && !isAdyenComponentValid()) {
    return {
      canceled: false,
      error: true,
      errorMessage: getAdyenComponentErrorMessage(),
    };
  }

  if (!isValidBilling()) {
    checkoutStage.methods.setStage(checkoutStage.stages.BILLING_ADDRESS);
    return {
      canceled: false,
      error: true,
    };
  }

  const klarnaValidation = await klarnaCheckout?.methods
    .validatePayment()
    .catch(() => ({
      approved: false,
      error: true,
    }));
  if (klarnaValidation.approved === false) {
    if (klarnaValidation.error) {
      return {
        canceled: false,
        error: true,
      };
    }
    return {
      canceled: true,
      error: false,
    };
  }

  let paymentForm = preparePaymentData();

  const invoiceRequested = $('.payment-form').attr('data-is-invoice-requested');
  if (invoiceRequested === 'true') {
    paymentForm += '&invoiceRequested=true';
  }

  return new Promise(
    (resolve) => {
      $.ajax({
        url: $(billingAddressFormSelector).attr('action'),
        method: 'POST',
        data: paymentForm,
        success(data) {
          if (data.storeStockChangedModalHtml) {
            modals.createCustomModal(data.storeStockChangedModalHtml, {
              backdrop: 'static',
              keyboard: false,
            });
            require('../storeLocator/storeStockChangedModal').init();
            const {
              setForceStoresReload,
            } = require('./instore').methods;
            setForceStoresReload(true);
            $('body').trigger('checkout:updateCheckoutView', {
              order: data.order,
              customer: data.customer,
            });
            resolve({
              canceled: true,
              error: false,
            });
            return;
          }

          handlePaymentSubmitResponse(data);
          updateBillingAddressSummary(data.order);
          resolve({
            canceled: false,
            error: false,
          });
        },
        error(err) {
          if (err.responseJSON && err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          }
          resolve({
            canceled: false,
            error: true,
          });
        },
      });
    },
  );
}

/**
 * update billing address summary and contact information
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateBillingAddressSummary(order) {
  if (!order || !order.billing) return;

  const { address } = order.billing.billingAddress;
  const addressContainer = $('.order-summary-billing .address-summary');

  // update billing address summary
  addressHelpers.methods.populateAddressSummary(addressContainer, address);

  // update billing parts of order summary
  $('.order-summary-email').text(order.orderEmail);

  const invoiceContainer = $('.order-summary-invoice');
  const invoiceCompanyName = invoiceContainer.find('.billing-company-name');
  const invoiceCif = invoiceContainer.find('.billing-cif');
  if (address && address.companyName && address.custom.byl_cif) {
    invoiceContainer.removeClass('d-none');
    invoiceCompanyName.text(address.companyName);
    invoiceCif.text(address.custom.byl_cif);
  } else {
    invoiceContainer.addClass('d-none');
  }
}

/**
 * Gets address properties from the billing-address form
 * @returns {Object} - a JSON object with all values
 */
function getBillingAddressFieldsFromUI() {
  const billingForm = $(billingAddressSelector);
  const addressObject = {};

  const fields = ['firstName', 'lastName', 'address1', 'address2', 'city', 'postalCode',
    'stateCode', 'byl_region', 'colonia', 'comunaCode', 'country', 'phone', 'phoneBody', 'phonePrefix'];

  fields.forEach((field) => {
    const node = $(`[name$=${field}]`, billingForm);
    if (node[0] && node[0].tagName === 'INPUT') {
      addressObject[field] = node.val();
    } else if (node[0] && node[0].tagName === 'SELECT') {
      const nodeName = $(`option[value = "${node.val()}"]`, node).text();
      addressObject[field] = field === 'country'
        ? `(${nodeName.trim()})`
        : nodeName;
    }
  });

  return addressObject;
}

/**
 * Update billing address summary from address in billing form
 * @param {Object} address - address object from form
 */
function updateBillingSummaryFromUI() {
  const address = getBillingAddressFieldsFromUI();
  const addressContainer = $('.order-summary-billing .address-summary');
  addressHelpers.methods.populateAddressSummary(addressContainer, address);
}

function selectSavedPaymentInstrument() {
  // Empty to override SFRA
}

function addNewPaymentInstrument() {
  // Empty to override SFRA
}

/** Validate billing-address-block
 * @returns {boolean} True if valid, false otherwise
 */
function isValidBilling() {
  const billingAddressBlock = document.querySelector(billingAddressBlockSelector);
  const billingAddressFields = billingAddressBlock.querySelectorAll('input, select, textarea');
  const paymentForm = billingAddressBlock.closest('.payment-form');

  const paymentFormErrorClass = 'payment-form--form-error';
  const isBillingValid = clientSideValidation.functions.validateFields(billingAddressFields);
  if (isBillingValid) {
    hideElementsBySelector(billingAddressFormErrorSelector);
    paymentForm.classList.remove(paymentFormErrorClass);
  } else {
    showElementsBySelector(billingAddressFormErrorSelector);
    paymentForm.classList.add(paymentFormErrorClass);
  }
  return isBillingValid;
}

function selectBillingAddress() {
  $('.payment-form .addressSelector').on('change', function billingAddressChange() {
    const form = $(this).parents('form')[0];
    const formSelector = '[name*=_billing_]:not([data-autocomplete-form=off])';
    let selectedOption = $('input:checked', this);
    if (selectedOption.length === 0) {
      const $newAddressOption = $('input', this);
      $newAddressOption[0].checked = true;
      selectedOption = $newAddressOption;
    }
    const optionID = selectedOption[0].value;

    if (optionID === 'new') {
      // Show Address
      $(form).attr('data-address-mode', 'new');
    } else {
      // Hide Address
      $(form).attr('data-address-mode', 'shipment');
    }

    // Copy fields
    const attrs = selectedOption.data();
    let element;

    Object.keys(attrs).forEach((attr) => {
      element = attr;
      const isCountryCode = attr === 'countryCode';
      const isStateCode = attr === 'stateCode';
      if (isCountryCode || isStateCode) {
        element = isCountryCode ? 'country' : attr;
        $.each($(`${formSelector}[name$=${element}]`, form), (index, country) => {
          if (country.options && country.options.length > 2) {
            $(`${formSelector}[name$=${element}]`, form).val(attrs[attr]);
          }
        });
      } else if (element === 'cardNumber') {
        $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
      } else if (attr === 'phone') {
        const phoneArray = attrs[attr].split(' ');
        const phoneBody = phoneArray.length === 2 ? phoneArray[1] : phoneArray[0];
        const phonePrefix = phoneArray.length === 2 ? phoneArray[0] : null;
        $(`${formSelector}[name$=${element}]`, form).val(phoneBody).trigger('change');
        const phonePrefixSelector = $('#billing-phone-prefix[name=phonePrefix]', form);
        if (phonePrefixSelector.length && phonePrefix) {
          phonePrefixSelector.val(phonePrefix);
          if (phonePrefixSelector[0].selectedIndex !== -1) {
            phonePrefixSelector.change();
          }
        }
      } else {
        $(`${formSelector}[name$=${element}]`, form).val(attrs[attr]);
      }
    });
  });
}

/**
 * clears the billing address form values
 */
function clearBillingAddressFormValues() {
  updateBillingAddressFormValues({
    billing: {
      billingAddress: {
        address: {
          countryCode: {},
        },
      },
    },
  });
}

function toggleAdyenPaymentMethodContent(paymentMethodType) {
  let firstVisiblePayment;
  const adyenPaymentMethodElements = document.querySelectorAll('#adyen-component-content .adyen-payment-method-type');
  if (!adyenPaymentMethodElements.length) {
    return;
  }
  adyenPaymentMethodElements.forEach((adyenPaymentMethod) => {
    if (adyenPaymentMethod.getAttribute('data-payment-method-type') === paymentMethodType) {
      adyenPaymentMethod.classList.remove('d-none');
      if (!firstVisiblePayment) {
        firstVisiblePayment = adyenPaymentMethod;
      }
    } else {
      adyenPaymentMethod.classList.add('d-none');
    }
  });
  if (firstVisiblePayment) {
    firstVisiblePayment.querySelector('input').click();
  }
}

/**
 * Checks selected Adyen payment method to show
 * corresponding content
 * @param {string} selectedMethodId
 */
function handleToggleAdyenPaymentMethodContent(selectedMethodId) {
  // Double underscore is used in Adyen custom methods to separate "AdyenComponent" and specific payment method name
  if (selectedMethodId.includes('__')) {
    const selectedMethodIdSuffix = selectedMethodId.split('__')[1];
    toggleAdyenPaymentMethodContent(selectedMethodIdSuffix);
  } else {
    toggleAdyenPaymentMethodContent(adyenPaymentMethods.CREDIT_CARD.type);
  }
}

function togglePaymentMethodsTabs(selectedMethodId) {
  const ACTIVE_CLASS = 'active';
  const selectedMethodTab = document.querySelector(`.payment-options [data-method-id=${selectedMethodId}] .nav-link`);

  const paymentInformation = document.querySelector('.payment-information');
  if (paymentInformation) {
    paymentInformation.dataset.paymentMethodId = selectedMethodId;
  }

  const paymentMethodsTabs = document.querySelectorAll('.payment-options .nav-link');
  const selectedMethodContent = selectedMethodTab && document.querySelector(selectedMethodTab.getAttribute('href'));
  // Deactivate all tabs
  forEachElement(paymentMethodsTabs, (tab) => {
    tab.classList.remove(ACTIVE_CLASS);
    // Deactivate tab related content
    document.querySelector(tab.getAttribute('href'))?.classList.remove(ACTIVE_CLASS);
  });
  // Activate selectedMethodId tab
  selectedMethodTab?.classList.add(ACTIVE_CLASS);
  selectedMethodContent?.classList.add(ACTIVE_CLASS);

  if (isAdyenComponentSelected() && selectedMethodId) {
    handleToggleAdyenPaymentMethodContent(selectedMethodId);
  }
}

function checkPaymentMethodToProcessAndResetAdyenSelectionIfneed(selectedMethodIdToProcess) {
  if (paymentMethods.AdyenComponent === selectedMethodIdToProcess) return;
  document.querySelectorAll('input.adyen-payment-method-type__input[type=radio]:checked')
    .forEach((eleInput) => {
      // eslint-disable-next-line no-param-reassign
      eleInput.checked = false;
    });
  try {
    const adyenCheckoutHelpers = require('on4u_adyen_SFRA/adyen_checkout/helpers');
    const store = require('adyen_SFRA/../../../store');
    store.selectedMethod = 'Others';
    adyenCheckoutHelpers.resetPaymentMethod();
  } catch (err) {
    // Ignore
  }
}

function processMBWayInputs() {
  const mbWayContainer = document.querySelector('.adyen-checkout__mb-way');

  const phoneNumberInput = mbWayContainer?.querySelector('.adyen-checkout-phone-number input');
  if (phoneNumberInput && phoneNumberInput.value !== '') {
    isAdyenComponentValid();
  }
}

function processSelectedMethodId(selectedMethodId) {
  if (!selectedMethodId || selectedMethodId === null) {
    return;
  }
  const paypalContentSelector = '.tab-pane.paypal-content';
  const applepayContentSelector = '.tab-pane.applepay-content';
  const submitPaymentBtnSelector = '.place-order-btn';
  const paymentDetailsNextStageBtnParent = document.querySelector('.payment-details__next-stage').closest('.form__actions');
  const $paypalContent = $(paypalContentSelector);
  const processedSelectedMethod = selectedMethodId.split('__');
  const processedMethodId = processedSelectedMethod[0];
  const processedMethodSuffix = processedSelectedMethod[1];

  $('#selectedPaymentOption').val(processedMethodId);

  togglePaymentMethodsTabs(selectedMethodId);

  // Hide invalid card error
  $('#invalidCardDetails').hide();

  // Hide form general error
  formHelpers.removeCheckoutError();

  if (selectedMethodId === paymentMethods.PAYPAL) {
    hideElementsBySelector(submitPaymentBtnSelector);
    hideElementsBySelector(applepayContentSelector);
    showElementsBySelector(paypalContentSelector);
    $paypalContent.find('input, textarea, select').removeAttr('disabled');
  } else if (selectedMethodId === paymentMethods.APPLE_PAY) {
    hideElementsBySelector(paypalContentSelector);
    hideElementsBySelector(submitPaymentBtnSelector);
    showElementsBySelector(applepayContentSelector);
    $paypalContent.find('input, textarea, select').attr('disabled', 'disabled');
  } else {
    if (processedMethodSuffix === adyenPaymentMethods.MB_WAY.type) {
      processMBWayInputs();
    }
    if (processedMethodSuffix === adyenPaymentMethods.GOOGLE_PAY.type) {
      paymentDetailsNextStageBtnParent.classList.add('d-none');
    } else {
      paymentDetailsNextStageBtnParent.classList.remove('d-none');
    }
    hideElementsBySelector(paypalContentSelector);
    hideElementsBySelector(applepayContentSelector);
    showElementsBySelector(submitPaymentBtnSelector);
    $paypalContent.find('input, textarea, select').attr('disabled', 'disabled');
  }
}

function clearBillingForm() {
  $('body').on('checkout:clearBillingForm', () => {
    clearBillingAddressFormValues();
  });
}

/**
 * clears the credit card form
 */
function clearCreditCardForm() {
  $('input[name$="_cardNumber"]').data('cleave')?.setRawValue('');
  $('select[name$="_expirationMonth"]').val('');
  $('select[name$="_expirationYear"]').val('');
  $('input[name$="_securityCode"]').val('');

  // Remove errors
  $('#invalidCardDetails').hide();
  $('.credit-card-selection-new')
    .find('.adyen-checkout__input--error')
    .removeClass('adyen-checkout__input--error');
}

/**
 * Rewrite method for missing credit card form in some cases
 */
function handleCreditCardNumber() {
  const cardNumber = document.querySelector('.cardNumber');
  const cardType = document.querySelector('#cardType');
  if (cardNumber && cardType) {
    cleave.handleCreditCardNumber('.cardNumber', '#cardType');
  }
}

function initBillingForm() {
  formUtils.initSelectInputs($(billingAddressBlockSelector));
}

/** Handle the suggestedAddressSelected vertex modal event & fill the billing form & submit the payment form
   */
function submitBillingWithVertexSuggestedAddress() {
  const addressCustomHelpers = require('./addressCustom');

  async function handleSuggestedAddressSelectedEvent(event) {
    if (!checkoutStage.methods.isStageFromPaymentGroup()) {
      return;
    }

    const suggestedAddress = event.detail;
    const paymentForm = document.querySelector('.payment-form');
    addressCustomHelpers.methods.changeFormAddressValuesByObject(suggestedAddress, paymentForm);
    updateBillingSummaryFromUI();
    checkoutStage.methods.setStage(checkoutStage.stages.PLACE_ORDER);
  }

  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  document.addEventListener('suggestedAddressSelected', handleSuggestedAddressSelectedEvent);
}

/**
 * Show billing address block and hides billing selector
 * @param {jQuery} billingForm  - current billing form
 */
function showOnlyBillingAddressBlock(billingForm) {
  hideElementsBySelector(billingAddressSelectorSelector, billingForm[0]);
  showElementsBySelector(billingAddressSelector, billingForm[0]);
}

/**
 * Show billing selector and hides billing address block
 * @param {jQuery} billingForm  - current billing form
 */
function showOnlyBillingSelectorBlock(billingForm) {
  hideElementsBySelector(billingAddressSelector, billingForm[0]);
  showElementsBySelector(billingAddressSelectorSelector, billingForm[0]);
}

/**
 * Select new address and show only address form
 * @param {jQuery} $billingForm
 */
function selectNewAddress($billingForm) {
  $('body').trigger('checkout:clearBillingForm');
  const $newEl = $billingForm.find('.addressSelector input[value=new]');
  $newEl.prop('checked', true).trigger('change');
  $billingForm.parents('[data-address-mode]').attr('data-address-mode', 'new');

  showOnlyBillingAddressBlock($billingForm);
}

/** Back to address selector or Payment details from new address block.
 * It automatically selects the first saved address if needed
*/
function handleBackFromBillingAddress() {
  $(`${billingAddressSelector}__back-to-address-selector`).on('click', (e) => {
    const $billingForm = $(e.target).parents('form');
    const billingForm = $billingForm[0];

    const optionID = $billingForm.find('.addressSelector input:checked')[0]?.value;
    if ((optionID === 'new' || billingForm.dataset.editSavedAddress === 'true')
      && $billingForm.find('.addressSelector input')?.length > 1
    ) {
      billingForm.dataset.editSavedAddress = false;
      const firstOption = $billingForm.find('.addressSelector input[value!=new]')[0];
      $(firstOption).prop('checked', true).trigger('change');
      updateBillingSummaryFromUI();
      showOnlyBillingSelectorBlock($billingForm);
    } else if ((isAdyenComponentSelected() && hasPaymentDetailsStage())
      || isAssistedShoppingSelected()) {
      this.methods.setStage(this.stages.PAYMENT_DETAILS);
    } else {
      this.methods.setStage(this.stages.PAYMENT_METHOD);
    }
  });
}

/**
 * Checks payment method and billing address to set
 *  suitable next stage: Payment_Details, Billing_Address or Place_Order
 *  @param {boolean} [methodId] Optional payment method Id. If not given, takes it from DOM (active nav-link).
 */
function handlePaymentMethodNextButton(methodId) {
  const selectedMethodId = methodId || document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode.dataset.methodId;

  if (!selectedMethodId) return;

  processSelectedMethodId(selectedMethodId);

  sessionStorage.setItem(PAYMENT_SESSION_ATTR, selectedMethodId);

  if ((isAdyenComponentSelected() && hasPaymentDetailsStage())
    || isAssistedShoppingSelected()
  ) {
    checkoutStage.methods.setStage(checkoutStage.stages.PAYMENT_DETAILS);
  } else if (isValidBilling()) {
    updateBillingSummaryFromUI();
    checkoutStage.methods.setStage(checkoutStage.stages.PLACE_ORDER);
  } else {
    formHelpers.clearPreviousErrors(billingAddressSelector);
    hideElementsBySelector(billingAddressFormErrorSelector);
    checkoutStage.methods.setStage(checkoutStage.stages.BILLING_ADDRESS);
  }
}

function isValidAssistedShopping() {
  const paymentNavItemElement = document
    .querySelector('.payment-options .nav-item .nav-link.active')?.parentNode;
  if (!paymentNavItemElement?.dataset) {
    return false;
  }

  const {
    methodId: selectedPaymentMethod = null
  } = paymentNavItemElement.dataset;

  let selectedPaymentMethodContainer;
  if (paymentMethods.ADYEN_PAYBYLINK.indexOf(selectedPaymentMethod) !== -1) {
    selectedPaymentMethodContainer = document.querySelector('.pay-by-link-content');
  } else if (paymentMethods.ADYEN_POS.indexOf(selectedPaymentMethod) !== -1) {
    selectedPaymentMethodContainer = document.querySelector('.adyen-POS-content');
  } else if (paymentMethods.REDELCOM.indexOf(selectedPaymentMethod) !== -1) {
    selectedPaymentMethodContainer = document.querySelector('.redelcom-content');
  } else if (
    paymentMethods.MERCADOPAGO_PAYBYLINK.indexOf(selectedPaymentMethod) !== -1
  ) {
    selectedPaymentMethodContainer = document.querySelector('.pay-by-link-content');
  } else {
    return false;
  }

  const inputsToValidate = selectedPaymentMethodContainer.querySelectorAll('input, select');
  return clientSideValidation.functions.validateFields(inputsToValidate, false);
}

/**
 * Checks Adyen validation and billing address to set
 *  suitable next stage: Billing_Address or Place_Order
 */
function handlePaymentDetailsNextButton() {
  if (isAdyenComponentSelected() && !isAdyenComponentValid()) {
    return;
  }
  if (isAssistedShoppingSelected()) {
    formHelpers.clearPreviousErrors('.payment-form');
    const isValid = isValidAssistedShopping();
    if (!isValid) return;
  }

  if (!isValidBilling()) {
    formHelpers.clearPreviousErrors(billingAddressSelector);
    hideElementsBySelector(billingAddressFormErrorSelector);
    checkoutStage.methods.setStage(checkoutStage.stages.BILLING_ADDRESS);
  } else {
    updateBillingSummaryFromUI();
    checkoutStage.methods.setStage(checkoutStage.stages.PLACE_ORDER);
  }
}

/** Checks if there is a valid payment.
 * For Adyen and Assisted Shopping, validates
 * addiotional fields. Else, if any payment is selected.
 * @return {boolean} is valid Payment
 */
function isValidPayment() {
  if (isAdyenComponentSelected() && isAdyenComponentValid()) {
    return true;
  }
  if (isAssistedShoppingSelected() && isValidAssistedShopping()) {
    return true;
  }

  const isPaymentSelected = document.querySelector('.payment-options .nav-link.active');
  return !!isPaymentSelected;
}

/**
 * Checks if payment and billing are valid
 * @returns {boolean} payment and billing address are valid
 */
function areBillingAndPaymentValid() {
  formHelpers.clearPreviousErrors('.payment-form');
  formHelpers.clearPreviousErrors(billingAddressSelector);

  return isValidPayment() && isValidBilling();
}

/*
 * Checks billing address to continue to place Order
*/
function handleBillingNextButton() {
  formHelpers.clearPreviousErrors(billingAddressSelector);

  if (isValidBilling()) {
    updateBillingSummaryFromUI();
    checkoutStage.methods.setStage(checkoutStage.stages.PLACE_ORDER);
  } else {
    const billingAddressSelectorElement = document.getElementById('billingAddressSelector');
    const selectedBillingAddressElement = billingAddressSelectorElement.querySelector('[name="addressSelector"]:checked');
    if (selectedBillingAddressElement.value !== 'new') {
      const paymentForm = document.querySelector('.payment-form');
      showOnlyBillingAddressBlock($(paymentForm));
    }
  }
}

/**
 *
 */
function toggleAdyenContentForSessionSavedPayment() {
  const sessionSelectedMethod = sessionStorage.getItem(PAYMENT_SESSION_ATTR);
  if (!sessionSelectedMethod) return;
  handleToggleAdyenPaymentMethodContent(sessionSelectedMethod);
  document.removeEventListener('adyen-genericcomponent-rendered', toggleAdyenContentForSessionSavedPayment);
}

function adyenGenericComponentRenderedEvent() {
  document.addEventListener('adyen-genericcomponent-rendered', toggleAdyenContentForSessionSavedPayment);
}

module.exports = Object.assign(base, {
  methods: {
    areBillingAndPaymentValid,
    billingDomData,
    checkPaymentMethodToProcessAndResetAdyenSelectionIfneed,
    clearBillingAddressFormValues,
    clearCreditCardForm,
    getPaymentFormData,
    handleBillingNextButton,
    handlePaymentDetailsNextButton,
    handlePaymentMethodNextButton,
    handlePaymentSubmitResponse,
    isValidBilling,
    processSelectedMethodId,
    selectNewAddress,
    showOnlyBillingAddressBlock,
    showOnlyBillingSelectorBlock,
    submitPayment,
    toggleAdyenPaymentMethodContent,
    updateBillingAddress,
    updateBillingAddressFormValues,
    updateBillingAddressSummary,
    updateBillingInformation,
    updateBillingSummaryFromUI,
    validateAndUpdateBillingPaymentInstrument,
  },
  PAYMENT_SESSION_ATTR,
  addNewPaymentInstrument,
  adyenGenericComponentRenderedEvent,
  clearBillingForm,
  handleBackFromBillingAddress,
  handleCreditCardNumber,
  init: initBillingForm,
  selectBillingAddress,
  selectSavedPaymentInstrument,
  submitBillingWithVertexSuggestedAddress,
});
